import React from 'react';
import ReactDOM from 'react-dom/client';
import { CombinedState } from 'redux';
import { Localization } from '@localina/core';
import './app/styles/index.scss';
import { LocalinaWidgetApi } from './app/api';
import App from './app/containers/App';
import { configureStore } from './app/store/configureStore';
import { IApplicationStore, IStoreContext } from './app/interfaces';

const context: IStoreContext = {
    widgetApi: new LocalinaWidgetApi(),
};

const store = configureStore({} as CombinedState<IApplicationStore>, context);
const i18n = Localization.init('widget');
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App store={store} i18n={i18n} />
    </React.StrictMode>,
);
